// Some organizations have `time_zone` stored as a POSIX TZ string (e.g. "EST5EDT")
// instead of an IANA zone name. Intl/dayjs.tz() throws RangeError for those,
// so map the known POSIX abbreviations to an equivalent IANA zone and validate
// the result before it's used anywhere.
const POSIX_TZ_MAP = {
  PST8PDT: "America/Los_Angeles",
  MST7MDT: "America/Denver",
  CST6CDT: "America/Chicago",
  EST5EDT: "America/New_York",
};

const isValidTimeZone = (timeZone) => {
  try {
    Intl.DateTimeFormat(undefined, { timeZone });
    return true;
  } catch (e) {
    return false;
  }
};

export const getSafeTimeZone = (timeZone, fallback = "UTC") => {
  const mapped = (timeZone && POSIX_TZ_MAP[timeZone]) || timeZone;
  return isValidTimeZone(mapped) ? mapped : fallback;
};

export default getSafeTimeZone;
